import { useApi } from './api';
import { readJsonResponse, type ApiResult } from './apiResponse';
import type { ActiveUsersResponse } from '../types/activeUsers';

export const useActiveUsersService = () => {
  const { apiFetch } = useApi();

  const listOnlineUsers = async (): Promise<ApiResult<ActiveUsersResponse>> => {
    try {
      const res = await apiFetch('/admin/active-users');
      return readJsonResponse<ActiveUsersResponse>(res);
    } catch (e) {
      return {
        ok: false,
        status: 0,
        data: null,
        error: e instanceof Error ? e.message : 'Error de conexión'
      };
    }
  };

  return { listOnlineUsers };
};
